import type { CastCollection, CastItem } from "@/types/aggregate-items";
$ function getItemId(item: CastItem | CastCollection) {
  if (item._type === "Item") {
    return item.listingId;
  } else if (item._type === "Collection") {
    return item.collectionId;
  }
  return "";
}

<evo-masonry
  class=`cast-discover-grid`
  on-load-more("handleLoadMore")
  key="masonry-grid"
  refreshKey=state.refreshKey
>
  <@title>Discover</@title>
  <for|item| of=state.items>
    <@item>
      <div class="cast-discover-grid__item" key=getItemId(item)>
        <if(item._type === "Item")>
          <cast-discover-item-card item=item/>
        </if>
        <else>
          <cast-discover-collection-card item=item/>
        </else>
      </div>
    </@item>
  </for>
  <if(!state.allItemsLoaded)>
    <@load-more-button on-click("handleLoadMore")>
      Load more
    </@load-more-button>
  </if>
</evo-masonry>
